import * as tslib_1 from "tslib";
import * as esriLoader from 'esri-loader';
// TODO: Is this the right context for Map?
var MapExtender = /** @class */ (function () {
    function MapExtender() {
    }
    MapExtender.construct = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, map, MCMap;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, esriLoader.loadModules(['esri/Map'], window.esriConfig)];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [_b.sent(), 1]), map = _a[0];
                        MCMap = function (properties) {
                            var tempMap = new map(properties);
                            if (properties) {
                                tempMap.Name = properties.Name;
                                tempMap.Description = properties.Description;
                                tempMap.Data = properties.Data;
                                tempMap.IsAdminMap = properties.IsAdminMap;
                                tempMap.CreatedDate = properties.CreatedDate;
                                tempMap.LastEditedDate = properties.LastEditedDate;
                                tempMap.IsPublic = properties.IsPublic;
                                tempMap.ShowOnAoi = properties.ShowOnAoi;
                                tempMap.UniqueName = properties.UniqueName;
                                tempMap.Categories = properties.Categories;
                            }
                            return tempMap;
                        };
                        return [2 /*return*/, MCMap];
                }
            });
        });
    };
    return MapExtender;
}());
export { MapExtender };
